import { render, staticRenderFns } from "./AdminPartnerCalculationsProductDetailPage.vue?vue&type=template&id=c171d756&scoped=true"
import script from "./AdminPartnerCalculationsProductDetailPage.vue?vue&type=script&lang=js"
export * from "./AdminPartnerCalculationsProductDetailPage.vue?vue&type=script&lang=js"
import style0 from "./AdminPartnerCalculationsProductDetailPage.vue?vue&type=style&index=0&id=c171d756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c171d756",
  null
  
)

export default component.exports